import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// --- Plugins
import JzComponentsPlugin from "@joyz/app-core/plugins/jz-components";
import JzI18nPlugin from "@joyz/app-core/plugins/jz-i18n";
import { i18nDictionary, getLanguage } from "./utils/internal/i18n";
import VMdPreview from "@kangc/v-md-editor/lib/preview";
import "@kangc/v-md-editor/lib/style/preview.css";
import githubTheme from "@kangc/v-md-editor/lib/theme/github.js";
import OneSignalWrapperPlugin from "@tt-app/utils/notifications/wrapperPlugin";
import { vCopy } from "@tt-app/utils";
import { defineCustomElements as defineTtComponents } from "@joyzartifact/tt-components/loader";
import "@joyzartifact/tt-components/dist/tt-components/tt-components.css";

require("./shims");
defineTtComponents();

VMdPreview.use(githubTheme);

// --- Styling (To be ported to app-core)
import "@tt-app/styles/main.scss";

Vue.use(JzComponentsPlugin);
Vue.use(JzI18nPlugin, { dictionary: i18nDictionary, getLanguage });
Vue.use(VMdPreview);
Vue.use(OneSignalWrapperPlugin);
Vue.directive("copy", vCopy);

// --- Global components
import TtBackBtn from "@tt-app/components/ui/TtBackBtn.vue";

Vue.component("tt-back-btn", TtBackBtn);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
